import { useCallback, useEffect } from "react";
import { usePlaidLink } from "react-plaid-link";
import { Loader2 } from "lucide-react";
import { apiPost } from "@/lib/apiAdmin";

export default function PlaidOAuth() {
  const token = localStorage.getItem("plaid_link_token");
  const finish = (ok) => { localStorage.removeItem("plaid_link_token"); window.location.replace(`/admin?bank=${ok ? "connected" : "failed"}`); };
  const onSuccess = useCallback((public_token, meta) => {
    apiPost("/admin/bank/exchange", { public_token, institution_name: meta?.institution?.name }).then(() => finish(true)).catch(() => finish(false));
  }, []);
  const { open, ready } = usePlaidLink({ token, onSuccess, onExit: () => finish(false), receivedRedirectUri: window.location.href });
  useEffect(() => { if (!token) finish(false); else if (ready) open(); }, [token, ready, open]);
  return (
    <div className="min-h-screen bg-[#05080C] flex items-center justify-center text-gray-300 gap-3" data-testid="plaid-oauth-page">
      <Loader2 className="w-5 h-5 animate-spin text-cyan-300" /> Finishing secure bank sign-in…
    </div>
  );
}
